import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { ServiceGroupService } from 'src/app/admin/admin-setup/service-group/service-group.service';
import { DepartmentService } from 'src/app/admin/department/department.service';
import { GroupService } from 'src/app/shared/services/group.service';
import { SuperGroupService } from 'src/app/admin/super-group/super-group.service';
import { AuthService } from 'src/app/core/account/auth.service';
import { User } from 'src/app/core/account/user.model';
import { TenantService } from 'src/app/tenant/tenant.service';
import { GetNameMember } from '../models/get-name-member.model';
import { ServiceGroup } from '../models/service-group.model';
import { GlobalService } from '../services/global.service';
import { MemberService } from '../services/member.service';
import { MemberSearchFilter } from './member-search-filter.model';
import { MemberSearch } from './member-search.model';
import { MemberSearchService } from './member-search.service';
import { ServiceService } from 'src/app/admin/service-setup/service.service';
import { ReducedService } from 'src/app/admin/service-setup/service.model';
import { formatDate } from '@angular/common';
import { start } from 'repl';
import { Extension, Occupation } from '../profile/profile/profile.model';
import { OccupationService } from '../profile/profile/occupation.service';
import { ProfileService } from '../profile/profile/profile.service';
import { MemberConfiguration } from '../profile/profile/member-configuration.model';
import { ViewportScroller } from '@angular/common';
import { TagService } from 'src/app/admin/tags/tag.service';
import { Tag } from '../models/tag.model';


@Component({
    selector: 'app-member-search',
    templateUrl: './member-search.component.html',
    styleUrls: ['./member-search.component.scss'],
    standalone: false
})
export class MemberSearchComponent implements OnInit, OnChanges {
  @Output() refreshPage = new EventEmitter();
  @Output() searchComplete = new EventEmitter();
  @Output() completedDisplay = new EventEmitter();
  @Output() onClear = new EventEmitter();
  @Input() DataScope: string;
  @Input() AccountHolder: string;
  @Input() ShowAdvancedSearch: string;
  @Input() AttendanceFilter: string;
  @Input() FollowupFilter: string;
  @Input() DonationFilter: string;
  @Input() AllDonationAccounts: string;
  @Input() NotesFilter: string;
  @Input() DefaultGroup: string;
  @Input() GroupType: string;
  @Input() EventId: number;
  @Input() CurrentSort: string;
  @Input() AutoSearchOnSort: boolean = true;  

  isLoading: boolean = true;
  isDiocese: boolean = false;
  searchForm: FormGroup = new FormGroup({});
  memberSearching: boolean = false;
  groupSearching: boolean = false;
  advancedSearch: boolean = false;
  groupArr: ServiceGroup[] = [];
  serviceArr: ReducedService[] = [];
  currentTask: number = 0;
  currentStatus: number = 0;
  currentAssignee: number = 0;
  assignees: GetNameMember[] = [];
  tenants: any = [];
  user: User;
  errorMessage: string = '';
  defaultIncludeAccounts: number = 0;
  occupations: Occupation[] = [];
  showMassText: boolean = false;
  memberConfigurations: MemberConfiguration[];
  formExtension: FormArray;
  collapseAttendance: boolean = true;
  collapseTask: boolean = true;
  collapseGiving: boolean = true;
  tags: Tag[];

  constructor(
    private authService: AuthService,
    private memberSearchService: MemberSearchService,
    private globalService: GlobalService,
    private ServiceGroup: ServiceGroupService,
    private tenantService: TenantService,
    public departmentService: DepartmentService,
    public superGroupService: SuperGroupService,
    public groupService: GroupService,
    private memberService: MemberService,
    private serviceService: ServiceService,
    private occupationService: OccupationService,
    private profileService: ProfileService,
    private fb: FormBuilder,
    private viewportScroller: ViewportScroller,
    private tagService: TagService
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    this.user = await this.authService.autoLogin(1);
    this.defaultIncludeAccounts = this.AllDonationAccounts == "true" ? 0 : 1;
    this.occupations = await this.occupationService.getOccupationList();
    this.memberConfigurations = await this.profileService.getMemberConfiguration();
    // if (this.CurrentSort == null)
    //   this.CurrentSort = 'first';
    if (this.memberSearchService.keepSelected == false) {
      this.memberSearchService.selectedMembers = [];
      this.memberSearchService.selectedAccounts = [];
      this.memberSearchService.memberArr = [];
    }
    if (this.user != null && this.ShowAdvancedSearch == 'true') {
      this.assignees = await this.memberService.getAssignees(this.user.id);
      this.ServiceGroup.loadActiveGroups();
      this.serviceArr = [];
      this.InitializeSearchForm();
      this.ClearFilter();
      this.superGroupService.loadActiveSuperGroups();
      this.departmentService.loadActiveDepartments();
      await this.groupService.loadActiveGroups();
      this.tags = await this.tagService.getActiveTags();
      this.groupArr = this.ServiceGroup.groupArr;
      this.tenants = await this.tenantService.getDioceseTenants();
      if (this.tenants.length > 1) this.isDiocese = true;
    }
    else
      this.InitializeSearchForm();
    //this.memberConfigurations = this.generateOptions();  
    this.isLoading = false;
    this.completedDisplay.emit();
  }

  get selectedTag() {
    const value = this.searchForm.get('tag')?.value;
    return this.tags?.find(t => t.id === value);
  }

  generateOptions() {
    let formExtensions = <FormArray>this.searchForm.controls.extensions;
    if (this.memberConfigurations != null && this.memberConfigurations.length > 0)
      this.memberConfigurations.forEach(a => {
        let selectable: boolean = a.options.indexOf(";") >= 0;
        var extension = this.fb.group({
          id: a.id,
          label: [a.label],
          options: selectable == true ? [a.options.split(';').map(item => item.trim())] : null,
          value: ['', Validators.nullValidator]
        });
        formExtensions.push(extension);
        if (a.options.indexOf(";") >= 0)
          a['optionsList'] = a.options.split(';').map(item => item.trim());
      });

    return this.memberConfigurations;
  }


ngOnChanges(changes) {

  if (changes.CurrentSort) {
    this.CurrentSort = changes.CurrentSort.currentValue;
  } 

  if (
      (changes.CurrentSort) &&
      this.AutoSearchOnSort &&
      this.searchForm &&
      Object.keys(this.searchForm.controls).length > 0
  ) {
      this.onSubmit();
  }
}

  async onCategoryChange() {
    var Category = this.searchForm.get('category').value;
    if (Category != null)
      this.serviceArr = await this.serviceService.getServicesByCategory(Category);
    else
      this.serviceArr = [];
  }

  date_range_changed() {
    if (this.searchForm.get('attendanceDateRange').value != null)
      this.memberSearchService.filter.attendanceDateRange = this.searchForm.get('attendanceDateRange').value;
    else
      this.memberSearchService.filter.attendanceDateRange = null;

    let currentDate = new Date();
    let endDate = formatDate(currentDate, 'yyyy-MM-dd', 'en');
    let dateStart = 0;

    if (this.memberSearchService.filter.attendanceDateRange == null) {
      this.searchForm.patchValue({ attendanceStartDate: null });
      this.searchForm.patchValue({ attendanceEndDate: null });
      return;
    }

    if (this.memberSearchService.filter.attendanceDateRange == 1 || this.memberSearchService.filter.attendanceDateRange == null)
      dateStart = currentDate.setDate(currentDate.getDate() - 6);

    if (this.memberSearchService.filter.attendanceDateRange == 2)
      dateStart = currentDate.setDate(currentDate.getDate() - 13);

    if (this.memberSearchService.filter.attendanceDateRange == 3)
      dateStart = currentDate.setDate(currentDate.getDate() - 20);

    if (this.memberSearchService.filter.attendanceDateRange == 4)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 1);

    if (this.memberSearchService.filter.attendanceDateRange == 5)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 3);

    if (this.memberSearchService.filter.attendanceDateRange == 6)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 6);

    if (this.memberSearchService.filter.attendanceDateRange == 7)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 12);

    if (this.memberSearchService.filter.attendanceDateRange == 8)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 60);

    if (this.memberSearchService.filter.attendanceDateRange == 9)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 1);

    let startDate = formatDate(dateStart, 'yyyy-MM-dd', 'en');
    this.searchForm.patchValue({ attendanceStartDate: startDate });
    this.searchForm.patchValue({ attendanceEndDate: endDate });

  }

  followup_date_range_changed() {
    if (this.searchForm.get('followupDateRange').value != null)
      this.memberSearchService.filter.followupDateRange = this.searchForm.get('followupDateRange').value;
    else
      this.memberSearchService.filter.followupDateRange = null;

    let currentDate = new Date();
    let endDate = formatDate(currentDate, 'yyyy-MM-dd', 'en');
    let dateStart = 0;

    if (this.memberSearchService.filter.followupDateRange == null) {
      this.searchForm.patchValue({ outReachStartDate: null });
      this.searchForm.patchValue({ outReachEndDate: null });
      return;
    }

    if (this.memberSearchService.filter.followupDateRange == 1)
      dateStart = currentDate.setDate(currentDate.getDate() - 6);

    if (this.memberSearchService.filter.followupDateRange == 2)
      dateStart = currentDate.setDate(currentDate.getDate() - 13);

    if (this.memberSearchService.filter.followupDateRange == 3)
      dateStart = currentDate.setDate(currentDate.getDate() - 20);

    if (this.memberSearchService.filter.followupDateRange == 4 || this.memberSearchService.filter.followupDateRange == null)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 1);

    if (this.memberSearchService.filter.followupDateRange == 5)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 3);

    if (this.memberSearchService.filter.followupDateRange == 6)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 6);

    if (this.memberSearchService.filter.followupDateRange == 7)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 12);

    if (this.memberSearchService.filter.followupDateRange == 8)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 60);

    if (this.memberSearchService.filter.followupDateRange == 9)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 1);

    let startDate = formatDate(dateStart, 'yyyy-MM-dd', 'en');
    this.searchForm.patchValue({ outReachStartDate: startDate });
    this.searchForm.patchValue({ outReachEndDate: endDate });

  }

  donation_date_range_changed() {
    if (this.searchForm.get('donationDateRange').value != null)
      this.memberSearchService.filter.donationDateRange = this.searchForm.get('donationDateRange').value;
    else
      this.memberSearchService.filter.donationDateRange = null;

    let currentDate = new Date();
    let endDate = formatDate(currentDate, 'yyyy-MM-dd', 'en');
    let dateStart = 0;

    if (this.memberSearchService.filter.donationDateRange == null) {
      this.searchForm.patchValue({ donationStart: null });
      this.searchForm.patchValue({ outReachEndDate: null });
      return;
    }

    if (this.memberSearchService.filter.donationDateRange == 1)
      dateStart = currentDate.setDate(currentDate.getDate() - 6);

    if (this.memberSearchService.filter.donationDateRange == 2)
      dateStart = currentDate.setDate(currentDate.getDate() - 13);

    if (this.memberSearchService.filter.donationDateRange == 3)
      dateStart = currentDate.setDate(currentDate.getDate() - 20);

    if (this.memberSearchService.filter.donationDateRange == 4 || this.memberSearchService.filter.donationDateRange == null)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 1);

    if (this.memberSearchService.filter.donationDateRange == 5)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 3);

    if (this.memberSearchService.filter.donationDateRange == 6)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 6);

    if (this.memberSearchService.filter.donationDateRange == 7)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 12);

    if (this.memberSearchService.filter.donationDateRange == 8)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 60);

    if (this.memberSearchService.filter.donationDateRange == 9)
      dateStart = currentDate.setMonth(currentDate.getMonth() - 1);

    let startDate = formatDate(dateStart, 'yyyy-MM-dd', 'en');
    this.searchForm.patchValue({ donationStartDate: startDate });
    this.searchForm.patchValue({ donationEndDate: endDate });

  }

  InitializeSearchForm() {
    if (this.ShowAdvancedSearch == 'false')
      this.memberSearchService.filter = null;
 
    let currentDate = new Date();
    let endDate = formatDate(currentDate, 'yyyy-MM-dd', 'en');
    let outreachEndDate = formatDate(currentDate, 'yyyy-MM-dd', 'en');
    let lastWeekDate = new Date();
    let lastWeek = lastWeekDate.setDate(lastWeekDate.getDate() - 6);
    let startDate = formatDate(lastWeek, 'yyyy-MM-dd', 'en');
    let outreachStartDate = formatDate(lastWeek, 'yyyy-MM-dd', 'en');
    let donationStartDate = startDate;
    let donationEndDate = endDate;

    if (this.AttendanceFilter == "false") {
      startDate = null;
      endDate = null;
    }

    if (this.FollowupFilter == "false") {
      outreachStartDate = null;
      outreachEndDate = null;
    }

    if (this.DonationFilter == "false") {
      donationStartDate = null;
      donationEndDate = null;
    }

    if (this.memberSearchService.filter == null) {
      this.searchForm = new FormGroup({
        firstName: new FormControl(this.globalService.memberSearchFirst),
        lastName: new FormControl(this.globalService.memberSearchLast),
        diocese: new FormControl(0),
        department: new FormControl(null),
        superGroup: new FormControl(null),
        group: new FormControl(null),
        email: new FormControl(''),
        phone: new FormControl(''),
        gender: new FormControl(null),
        maritalStatus: new FormControl(null),
        occupation: new FormControl(null),
        account: new FormControl(null),
        role: new FormControl(null),
        age: new FormControl(''),
        grade: new FormControl(''),
        city: new FormControl(''),
        state: new FormControl(''),
        zip: new FormControl(''),
        membership: new FormControl(null),
        picture: new FormControl(null),
        category: new FormControl(null),
        service: new FormControl(null),
        attendanceStartDate: new FormControl(startDate),
        attendanceEndDate: new FormControl(endDate),
        attendanceDateRange: new FormControl(1),
        followupDateRange: new FormControl(1),
        donationDateRange: new FormControl(1),
        attendanceStatus: new FormControl(2),
        outReachStatus: new FormControl(null),
        outReachTask: new FormControl(null),
        outReachStartDate: new FormControl(outreachStartDate),
        outReachEndDate: new FormControl(outreachEndDate),
        outReachAssignee: new FormControl(null),
        frequency: new FormControl(0),
        frequencyType: new FormControl(1),
        donationStartDate: new FormControl(donationStartDate),
        donationEndDate: new FormControl(donationEndDate),
        singleDonationMode: new FormControl(false),
        donationStartRange: new FormControl(0),
        donationEndRange: new FormControl(0),
        includeAccounts: new FormControl(this.defaultIncludeAccounts),
        extensions: this.fb.array([]),
        tag: new FormControl(0),
        result: new FormControl(1),
        has_role: new FormControl(null),
        note_selection: new FormControl(null),
        notification: new FormControl(0)
      });
      this.memberSearchService.filter = new MemberSearchFilter();
    } else {
      this.advancedSearch = false;
      this.searchForm = new FormGroup({
        firstName: new FormControl(this.memberSearchService.filter.firstName),
        lastName: new FormControl(this.memberSearchService.filter.lastName),
        diocese: new FormControl(this.memberSearchService.filter.diocese),
        department: new FormControl(this.memberSearchService.filter.department),
        superGroup: new FormControl(this.memberSearchService.filter.superGroup),
        group: new FormControl(this.memberSearchService.filter.group),
        email: new FormControl(this.memberSearchService.filter.email),
        phone: new FormControl(this.memberSearchService.filter.phone),
        gender: new FormControl(this.memberSearchService.filter.gender),
        maritalStatus: new FormControl(
          this.memberSearchService.filter.maritalStatus
        ),
        occupation: new FormControl(this.memberSearchService.filter.occupation),
        account: new FormControl(this.memberSearchService.filter.account),
        role: new FormControl(null),
        age: new FormControl(this.memberSearchService.filter.age),
        grade: new FormControl(this.memberSearchService.filter.grade),
        city: new FormControl(this.memberSearchService.filter.city),
        state: new FormControl(this.memberSearchService.filter.state),
        zip: new FormControl(this.memberSearchService.filter.zip),
        membership: new FormControl(this.memberSearchService.filter.membership),
        picture: new FormControl(this.memberSearchService.filter.picture),
        category: new FormControl(this.memberSearchService.filter.category),
        service: new FormControl(this.memberSearchService.filter.service),
        attendanceStartDate: this.memberSearchService.filter.attendanceStartDate == null ? new FormControl(startDate) : new FormControl(this.memberSearchService.filter.attendanceStartDate),
        attendanceEndDate: this.memberSearchService.filter.attendanceEndDate == null ? new FormControl(endDate) : new FormControl(this.memberSearchService.filter.attendanceEndDate),
        attendanceDateRange: this.memberSearchService.filter.attendanceDateRange == null ? new FormControl(1) : new FormControl(this.memberSearchService.filter.attendanceDateRange),
        followupDateRange: this.memberSearchService.filter.followupDateRange == null ? new FormControl(1) : new FormControl(this.memberSearchService.filter.followupDateRange),
        donationDateRange: this.memberSearchService.filter.donationDateRange == null ? new FormControl(1) : new FormControl(this.memberSearchService.filter.donationDateRange),
        frequency: new FormControl(this.memberSearchService.filter.frequency),
        frequencyType: this.memberSearchService.filter.frequencyType == null ? new FormControl(1) : new FormControl(
          this.memberSearchService.filter.frequencyType
        ),
        attendanceStatus: new FormControl(
          this.memberSearchService.filter.attendanceStatus
        ),
        outReachStatus: new FormControl(
          this.memberSearchService.filter.outReachStatus
        ),
        outReachTask: new FormControl(
          this.memberSearchService.filter.outReachTask
        ),
        outReachStartDate: this.memberSearchService.filter.outReachStartDate == null ?
          new FormControl(outreachStartDate) :
          new FormControl(
            this.memberSearchService.filter.outReachStartDate
          ),
        outReachEndDate: this.memberSearchService.filter.outReachEndDate == null ?
          new FormControl(outreachEndDate) :
          new FormControl(
            this.memberSearchService.filter.outReachEndDate
          ),
        outReachAssignee: new FormControl(
          this.memberSearchService.filter.outReachAssignee
        ),
        donationStartDate: this.memberSearchService.filter.donationStartDate == null ?
          new FormControl(donationStartDate) :
          new FormControl(
            this.memberSearchService.filter.donationStartDate
          ),
        donationEndDate: this.memberSearchService.filter.donationEndDate == null ?
          new FormControl(donationEndDate) :
          new FormControl(
            this.memberSearchService.filter.donationEndDate
          ),
        singleDonationMode: new FormControl(this.memberSearchService.filter.singleDonationMode),
        donationStartRange: this.memberSearchService.filter.donationStartRange == null ? new FormControl(0)
          : new FormControl(this.memberSearchService.filter.donationStartRange),
        donationEndRange: this.memberSearchService.filter.donationEndRange == null ? new FormControl(0)
          : new FormControl(this.memberSearchService.filter.donationEndRange),
        includeAccounts: this.memberSearchService.filter?.includeAccounts == null ? new FormControl(0) : new FormControl(this.memberSearchService.filter?.includeAccounts),
        extensions: this.memberSearchService.filter?.extensionValues == null || this.memberSearchService.filter?.extensionValues.length == 0 ? this.fb.array([]) : this.LoadExtensionsFromFilter(this.memberSearchService.filter.extensionValues)?.value,
        result: new FormControl(this.memberSearchService.filter.result),
        tag: new FormControl(this.memberSearchService.filter.tag),
        has_role: new FormControl(this.memberSearchService.filter.has_role),
        note_selection: new FormControl(
          this.memberSearchService.filter.note_selection
        ),
        notification: new FormControl(
          this.memberSearchService.filter.notification
        )
      });
    }
  }

  LoadExtensionsFromFilter(extensions: Extension[]) {
    let formArray = this.formExtension as FormArray;
    if (formArray != null && formArray.controls != null && formArray.controls.length > 0)
      formArray.controls.forEach(control => {
        let id = control.get("id").value;
        let value = extensions == null || extensions.filter(a => a.key == id) == null
          || extensions.filter(a => a.key == id).length == 0 ?
          "" : extensions.filter(a => a.key == id)[0].value;
        control.get("value").setValue(value);
      });
    return formArray;
  }

  get extensions(): FormArray {
    return this.searchForm.get('extensions') as FormArray;
  }

  LoadExtensionsFromForm() {

  }

  SetupForm(filter: MemberSearchFilter) {
    let currentDate = new Date();
    let endDate = formatDate(currentDate, 'yyyy-MM-dd', 'en');
    let outreachEndDate = formatDate(currentDate, 'yyyy-MM-dd', 'en');
    let lastWeekDate = new Date();
    let lastWeek = lastWeekDate.setDate(lastWeekDate.getDate() - 6);
    let startDate = formatDate(lastWeek, 'yyyy-MM-dd', 'en');
    let outreachStartDate = formatDate(lastWeek, 'yyyy-MM-dd', 'en');
    let donationStartDate = startDate;
    let donationEndDate = endDate;

    this.searchForm = new FormGroup({
      firstName: new FormControl(filter.firstName),
      lastName: new FormControl(filter.lastName),
      department: new FormControl(filter.department),
      superGroup: new FormControl(filter.superGroup),
      group: new FormControl(filter.group),
      email: new FormControl(filter.email),
      phone: new FormControl(filter.phone),
      gender: new FormControl(filter.gender),
      maritalStatus: new FormControl(filter.maritalStatus),
      occupation: new FormControl(filter.occupation),
      account: new FormControl(filter.account),
      role: new FormControl(null),
      age: new FormControl(this.ConvertNumArrayToString(filter.age)),
      grade: new FormControl(this.ConvertNumArrayToString(filter.grade)),
      city: new FormControl(this.ConvertStrArrayToString(filter.city)),
      state: new FormControl(this.ConvertStrArrayToString(filter.state)),
      zip: new FormControl(
        this.ConvertToNum(filter.zip) == null
          ? this.ConvertStrArrayToString(filter.zip)
          : this.ConvertNumArrayToString(this.ConvertToNum(filter.zip))
      ),
      membership: new FormControl(filter.membership),
      picture: new FormControl(filter.picture),
      category: new FormControl(filter.category),
      service: new FormControl(filter.service),
      attendanceStartDate: filter.attendanceStartDate == null ? new FormControl(startDate) : new FormControl(filter.attendanceStartDate),
      attendanceEndDate: filter.attendanceEndDate == null ? new FormControl(endDate) : new FormControl(filter.attendanceEndDate),
      attendanceDateRange: filter.attendanceDateRange == null ? new FormControl(1) : new FormControl(filter.attendanceDateRange),
      frequency: new FormControl(filter.frequency),
      frequencyType: filter.frequencyType == null ? new FormControl(1) : new FormControl(filter.frequencyType),
      attendanceStatus: new FormControl(filter.attendanceStatus),
      outReachStatus: new FormControl(filter.outReachStatus),
      outReachTask: new FormControl(filter.outReachTask),
      outReachStartDate: filter.outReachStartDate == null ? new FormControl(outreachStartDate) : new FormControl(filter.outReachStartDate),
      outReachEndDate: filter.outReachEndDate == null ? new FormControl(outreachEndDate) : new FormControl(filter.outReachEndDate),
      followupDateRange: filter.followupDateRange == null ? new FormControl(1) : new FormControl(filter.followupDateRange),
      outReachAssignee: new FormControl(filter.outReachAssignee),
      donationDateRange: filter.donationDateRange == null ? new FormControl(1) : new FormControl(filter.donationDateRange),
      donationStartDate: filter.donationStartDate == null ? new FormControl(donationStartDate) : new FormControl(filter.donationStartDate),
      donationEndDate: filter.donationEndDate == null ? new FormControl(donationEndDate) : new FormControl(filter.donationEndDate),
      singleDonationMode: filter.singleDonationMode == null ? new FormControl(false) : new FormControl(filter.singleDonationMode),
      donationStartRange: filter.donationStartRange == null ? new FormControl(0) : new FormControl(filter.donationStartRange),
      donationEndRange: filter.donationEndRange == null ? new FormControl(0) : new FormControl(filter.donationEndRange),
      includeAccounts: filter.includeAccounts == null ? new FormControl(0) : new FormControl(filter.includeAccounts),
      tag: filter.tag == null ? new FormControl(0): new FormControl(filter.tag),
      result: new FormControl(filter.result),
      has_role: new FormControl(filter.has_role),
      note_selection: new FormControl(filter.note_selection),
      notification: filter.notification == null ? new FormControl(0) : new FormControl(filter.notification)
    });
  }

  isNumeric(value) {
    return /^\d+$/.test(value);
  }

  GroupName() {
    return 'SHOWGROUP_' + this.GroupType;
  }

  ClearFilter() {
    this.memberSearchService.filter = null;
    this.memberSearchService.memberArr = [];
    this.globalService.memberSearchFirst = '';
    this.globalService.memberSearchLast = '';
    this.globalService.page = 1;
    this.onClear.emit();
    this.InitializeSearchForm();
    this.memberConfigurations = this.generateOptions();
  }

  ClearOnlyFilter() {
    this.memberSearchService.filter = {
      diocese: 0,
      firstName: '',
      lastName: '',
      department: 0,
      superGroup: 0,
      group: 0,
      email: '',
      phone: '',
      gender: null,
      maritalStatus: null,
      occupation: null,
      account: null,
      role: null,
      age: [],
      grade: [],
      city: [],
      state: [],
      zip: [],
      membership: null,
      picture: null,
      category: null,
      service: null,
      attendanceStartDate: null,
      attendanceEndDate: null,
      attendanceDateRange: null,
      followupDateRange: null,
      donationDateRange: null,
      frequency: 0,
      frequencyType: null,
      result: 1,
      leaders: false,
      has_role: null,
      note_selection: null,
      birthdayMonth: 0,
      birthdayDay: 0,
      attendanceStatus: 2,
      outReachStatus: null,
      outReachTask: null,
      outReachStartDate: null,
      outReachEndDate: null,
      outReachAssignee: null,
      donationStartDate: null,
      donationEndDate: null,
      singleDonationMode: false,
      donationStartRange: 0,
      donationEndRange: 0,
      includeAccounts: this.defaultIncludeAccounts,
      massText: false,
      tag: 0,
      notification: 0,
      extensionValues: []
    };
    this.memberSearchService.memberArr = [];
    this.globalService.memberSearchFirst = '';
    this.globalService.memberSearchLast = '';
    this.globalService.page = 1;
  }

  SplitToArrayNumber(valueString: any): number[] {
    if (Array.isArray(valueString) == true) return valueString;
    if (valueString == null || valueString.trim() == '') return [];
    valueString = valueString.trim();
    let result: number[] = [];
    let splits = valueString.split(',');
    splits.forEach((split) => {
      split = split.trim();
      if (split.indexOf('-') > 0) {
        let ranges = split.split('-');
        if (
          ranges.length == 2 &&
          this.isNumeric(ranges[0].trim()) &&
          this.isNumeric(ranges[1].trim()) &&
          parseInt(ranges[0].trim()) < parseInt(ranges[1].trim())
        ) {
          for (
            var i = parseInt(ranges[0].trim());
            i <= parseInt(ranges[1].trim());
            i++
          ) {
            result.push(i);
          }
        } else return [];
      } else {
        if (split.trim() != '') {
          if (this.isNumeric(split) == true) result.push(parseInt(split));
          else return [];
        }
      }
    });
    return result;
  }

  SplitToArrayString(valueString: any): string[] {
    if (Array.isArray(valueString) == true) return valueString;
    if (valueString == null || valueString.trim() == '') return [];
    valueString = valueString.trim();
    let result: string[] = [];
    let splits = valueString.split(',');
    splits.forEach((split) => {
      if (split.trim() != '') result.push(split.trim());
    });
    return result;
  }

  AttemptSplitToArrayNumber(valueString: any) {
    if (Array.isArray(valueString) == true) return valueString;
    let result = [];
    if (valueString == null || valueString.trim() == '') return [];
    valueString = valueString.trim();
    let numlist = this.SplitToArrayNumber(valueString);
    if (numlist.length == 0) result = this.SplitToArrayString(valueString);
    else result = this.ConvertToString(numlist);
    return result;
  }

  ConvertToString(nums: number[]): string[] {
    let result = [];
    nums.forEach((a) => result.push(a.toString()));
    return result;
  }

  ConvertToNum(strs: string[]): number[] {
    try {
      let result: number[] = [];
      strs.forEach((a) => result.push(parseInt(a)));
      return result;
    } catch (error) {
      null;
    }
  }

  ConvertNumArrayToString(arr: number[]): string {
    var result = '';
    if (arr == null)
      return result;
    arr = arr.sort((n1, n2) => n1 - n2);
    var counter = 0;
    while (counter <= arr.length - 1) {
      if (arr[counter + 1] - arr[counter] > 1 || counter == arr.length - 1)
        result = result + arr[counter] + ', ';
      else {
        var start = arr[counter];
        var current = arr[counter];
        counter = counter + 1;

        while (counter <= arr.length - 1 && arr[counter] - current == 1) {
          current = arr[counter];
          counter = counter + 1;
        }
        result = result + start + ' - ' + current + ', ';
      }
      counter = counter + 1;
    }
    if (result != null) result = result.trim();
    if (result[result.length - 1] == ',')
      result = result.substring(0, result.length - 1);
    return result;
  }

  ConvertStrArrayToString(arr: string[]): string {
    if (arr == null)
      return '';
    return arr.join(', ');
  }

  getExtensions() {
    let result: Extension[] = [];
    if (this.extensions != null)
      this.extensions.value.forEach(a => {
        let x: Extension = { key: a.id, value: a.value };
        result.push(x);
      });
    return result;
  }

  loadFilter() {
    this.memberSearchService.filter = {
      diocese: this.searchForm.get('diocese') == null ? 0 : this.searchForm.get('diocese')?.value,
      firstName: this.searchForm.get('firstName').value == null ? '' : this.searchForm.get('firstName').value,
      lastName: this.searchForm.get('lastName').value == null ? '' : this.searchForm.get('lastName').value,
      department:
        this.searchForm.get('department').value == null
          ? 0
          : this.searchForm.get('department').value,
      superGroup:
        this.searchForm.get('superGroup').value == null
          ? 0
          : this.searchForm.get('superGroup').value,
      group:
        this.searchForm.get('group').value == null
          ? 0
          : this.searchForm.get('group').value,
      email: this.searchForm.get('email').value == null ? '' : this.searchForm.get('email').value,
      phone: this.searchForm.get('phone').value == null ? '' : this.searchForm.get('phone').value,
      gender: this.searchForm.get('gender').value,
      maritalStatus: this.searchForm.get('maritalStatus').value,
      occupation: this.searchForm.get('occupation').value,
      account: this.searchForm.get('account').value,
      role: this.searchForm.get('role').value,
      age: this.SplitToArrayNumber(this.searchForm.get('age').value),
      grade: this.SplitToArrayNumber(this.searchForm.get('grade').value),
      city: this.SplitToArrayString(this.searchForm.get('city').value),
      state: this.SplitToArrayString(this.searchForm.get('state').value),
      zip: this.AttemptSplitToArrayNumber(this.searchForm.get('zip').value),
      membership: this.searchForm.get('membership').value,
      picture: this.searchForm.get('picture').value,
      category: this.searchForm.get('category').value,
      service: this.searchForm.get('service').value,
      attendanceStartDate: this.searchForm.get('attendanceStartDate').value,
      attendanceEndDate: this.searchForm.get('attendanceEndDate').value,
      attendanceDateRange: this.searchForm.get('attendanceDateRange').value,
      followupDateRange: this.searchForm.get('followupDateRange').value,
      donationDateRange: this.searchForm.get('donationDateRange').value,
      frequency: this.searchForm.get('frequency').value == null ? 0 : parseInt(this.searchForm.get('frequency').value),
      frequencyType: this.searchForm.get('frequencyType').value,
      attendanceStatus: this.searchForm.get('attendanceStatus').value,
      outReachStatus: this.searchForm.get('outReachStatus').value,
      outReachTask: this.searchForm.get('outReachTask').value,
      outReachStartDate: this.searchForm.get('outReachStartDate').value,
      outReachEndDate: this.searchForm.get('outReachEndDate').value,
      outReachAssignee: this.searchForm.get('outReachAssignee').value,
      result: this.searchForm.get('result').value == null ? 1 : this.searchForm.get('result').value,
      has_role: this.searchForm.get('has_role').value,
      note_selection: this.searchForm.get('note_selection').value,
      leaders: false,
      birthdayMonth: 0,
      birthdayDay: 0,
      donationStartDate: this.searchForm.get('donationStartDate').value,
      donationEndDate: this.searchForm.get('donationEndDate').value,
      singleDonationMode: this.searchForm.get('singleDonationMode').value,
      donationStartRange: this.searchForm.get('donationStartRange').value,
      donationEndRange: this.searchForm.get('donationEndRange').value,
      includeAccounts: this.searchForm.get('includeAccounts').value,
      notification: this.searchForm.get('notification').value,
      tag: this.searchForm.get('tag').value,
      massText: this.showMassText,
      extensionValues: this.getExtensions(),
    };
    this.memberSearchService.age = this.searchForm.get('age').value;
    this.memberSearchService.grade = this.searchForm.get('grade').value;
    this.memberSearchService.city = this.searchForm.get('city').value;
    this.memberSearchService.state = this.searchForm.get('state').value;
    this.memberSearchService.zip = this.searchForm.get('zip').value;
    this.searchForm.markAsDirty();
  }

  FrequencyTypeChanged() {
    if (
      this.searchForm.get('attendance').value == null ||
      this.searchForm.get('frequency').value == null
    ) {
      this.searchForm.patchValue({ frequency: 0 });
      this.memberSearchService.filter.frequency = 0;
    }
  }

  donationModeChanged() {
    this.memberSearchService.filter.singleDonationMode =
      this.searchForm.get('singleDonationMode').value;
  }

  includeAccountsChanged() {
    this.memberSearchService.filter.includeAccounts =
      this.searchForm.get('includeAccounts').value;
  }

  statusChanged() {
    this.searchForm.patchValue({
      attendanceStatus: this.searchForm.get('attendanceStatus').value,
    });
    this.memberSearchService.filter.attendanceStatus =
      this.searchForm.get('attendanceStatus').value;
  }

  getSortValue(currentSort) {
    switch (currentSort) {
      case 'first': return true;
      case 'last': return false;
      case 'recency': return null;
    }
  }

  assigneeChanged(selection) {
    this.searchForm.patchValue({
      outReachAssignee:
        this.assignees[selection.target.selectedIndex - 1]['id'],
    });
    this.memberSearchService.filter.outReachAssignee =
      this.assignees[selection.target.selectedIndex - 1]['id'];
  }

  toggleMassText() {
    this.showMassText = !this.showMassText;
  }

  async onSubmit() {
    if (this.searchForm == null)
      return;
    this.refreshPage.emit();

    this.advancedSearch = false;
    this.collapseAttendance = true;
    this.collapseGiving = true;
    this.collapseTask = true;

    this.memberSearchService.lastClickedMember = false;
    if (this.memberSearchService.keepSelected == false) {
      this.memberSearchService.selectedMembers = [];
      this.memberSearchService.selectedAccounts = [];
    }
    this.memberSearchService.memberArr = [];
    this.globalService.memberSearchFirst =
      this.searchForm.get('firstName').value;
    this.globalService.memberSearchLast = this.searchForm?.get('lastName').value;
    this.loadFilter();

    this.memberSearching = true;
    if (this.DataScope == 'Members') {
      this.memberSearchService.filter.membership = true;
      this.memberSearchService.filter.account = 0;
    }
    if (this.EventId == null) {
      this.memberSearchService.searchResult =
        await this.memberSearchService.AdvancedSearch(
          this.memberSearchService.filter,
          'pageNumber=1&pageSize=20', this.getSortValue(this.CurrentSort)
        ).catch(error => this.errorMessage = error.error);
    }
    else
      this.memberSearchService.searchResult =
        await this.memberSearchService.ScopedAdvancedSearch(
          this.EventId,
          this.memberSearchService.filter,
          'pageNumber=1&pageSize=20'
        ).catch(error => this.errorMessage = error.error);

    var Category = this.searchForm.get('category').value == null ? '' :
      this.groupArr.filter(a => a.id == this.searchForm.get('category').value)[0]?.name;
    var Service = this.searchForm.get('service').value == null ? '' :
      this.serviceArr.filter(a => a.id == this.searchForm.get('service').value)[0]?.name;
    if (Category == '' && Service == '')
      this.globalService.AttendanceService = "All Activities";
    else {
      if (Service == '')
        this.globalService.AttendanceService = Category;
      else {
        if (Category == '')
          this.globalService.AttendanceService = Service;
        else
          this.globalService.AttendanceService = Category + " - " + Service;
      }
    }

    var StartDate = this.searchForm.get('attendanceStartDate').value;
    var EndDate = this.searchForm.get('attendanceEndDate').value;

    var Department = "";
    var SuperGroup = "";
    var Group = "";
    if (this.searchForm.get('department').value != null) {
      var FoundDepartment = this.departmentService.departmentArr.filter(a => a.id == this.searchForm.get('department').value);
      if (FoundDepartment.length > 0)
        Department = FoundDepartment[0].name;
    }

    if (this.searchForm.get('superGroup').value != null) {
      var FoundSuperGroup = this.superGroupService.superGroupArr.filter(a => a.id == this.searchForm.get('superGroup').value);
      if (FoundSuperGroup.length > 0)
        SuperGroup = FoundSuperGroup[0].name;
    }

    if (this.searchForm.get('group').value != null) {
      var FoundGroup = this.groupService.GroupArr.filter(a => a.id == this.searchForm.get('group').value);
      if (FoundGroup.length > 0)
        Group = FoundGroup[0].name;
    }

    this.globalService.AttendanceGroup = (Department + " " + SuperGroup + " " + Group).trim();

    if (StartDate != null && EndDate != null)
      this.globalService.AttendanceDateRange = formatDate(StartDate, 'MM/dd/yyyy', 'en') + " - " + formatDate(EndDate, 'MM/dd/yyyy', 'en');
    else
      this.globalService.AttendanceDateRange = '';

    this.memberSearching = false;
    this.globalService.page = 1;
    //this.viewportScroller.scrollToAnchor("AnchorId");
    this.searchComplete.emit();
  }

  async ShowGroup() {
    this.refreshPage.emit();
    this.memberSearchService.lastClickedMember = true;
    this.memberSearchService.memberArr = [];
    if (this.memberSearchService.keepSelected == false) {
      this.memberSearchService.selectedMembers = [];
      this.memberSearchService.selectedAccounts = [];
    }
    
    let tempLeader = this.memberSearchService.filter.leaders;
    this.ClearOnlyFilter();
    this.groupSearching = true;
    if (this.GroupType == 'MEMBERS')
      this.memberSearchService.filter.group = parseInt(this.DefaultGroup);
    if (this.GroupType == 'SUPERGROUPS')
      this.memberSearchService.filter.superGroup = parseInt(this.DefaultGroup);
    if (this.GroupType == 'DEPARTMENTS')
      this.memberSearchService.filter.department = parseInt(this.DefaultGroup);

    this.memberSearchService.filter.leaders = tempLeader;
    if (this.EventId == null)
      this.memberSearchService.searchResult =
        await this.memberSearchService.AdvancedSearch(
          this.memberSearchService.filter,
          'pageNumber=1&pageSize=20', true
        );
    else
      this.memberSearchService.searchResult =
        await this.memberSearchService.ScopedAdvancedSearch(
          this.EventId,
          this.memberSearchService.filter,
          'pageNumber=1&pageSize=20'
        );
    // this.loadFilter();
    // if (this.advancedSearch == false) this.memberSearchService.filter = null;
    this.groupSearching = false;
    this.globalService.page = 1;
    this.searchComplete.emit();
  }

  clearService() {
    this.searchForm.patchValue({ 'service': null });
  }

  clearCategory() {

    this.searchForm.patchValue({ 'category': null });

  }
}
